// TSS vite/03 §"Query keys convention".
// Tuples, entity-name first, scope narrowing rightward.
// Centralizing here lets invalidation target a slice precisely.

export const recipientKeys = {
    all:    ['recipients'],
    list:   (filters) => ['recipients', filters],
    detail: (id) => ['recipients', id],
    // Agregado de receptoras (public/stats?view=kpi → data.recipients_kpi).
    kpi:    () => ['recipients', 'kpi'],
};
